"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_CONTENT = void 0;
const DELETE_CONTENT = exports.DELETE_CONTENT = 'delete-content';
